module.exports = __webpack_public_path__ + "img/image4.eced2bac.png";